import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class AchievementsRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async getTrailSummaryData(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.achievementsTrails.byUser(params?.trailId),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPhaseDetailsData(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.achievementsTrails.phaseDetails(params?.phaseId),
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async showCompletedTrail(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.achievementsTrails.showCompletedTrail(params?.trailId),
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async assignTrail(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.achievementsTrails.assign,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async redeem(
    params: { rewardId: string; date?: Date | string; adults?: number; children?: number }
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.achievementsTrails.redeem(params?.rewardId),
      body: params?.date !== undefined
        ? { date: params.date, adults: params.adults, children: params.children }
        : undefined,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

}
